import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web/lib/useKeycloak";
import { TUserInfo } from "../../@types/user-info.type";
import { getAllTenantsByAccount } from "../../services/api/tenant/TenantService";
import { ITenant } from "../../@types/tenant.type";
import { storageSelectedTenantGet, storageSelectedTenantSave } from "../../storage/storageSelectedTenant";
import TextField from "@mui/material/TextField/TextField";
import { IKeyText } from "../../@types/key-value.type";

export const TenantSelect = () => {
  const [userInfo, setUserInfo] = useState<TUserInfo>({} as TUserInfo);
  const { keycloak, initialized } = useKeycloak();
  const [tenants, setTenants] = useState<IKeyText[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<IKeyText>();

  const loadUserInfo = async () => {
    const user = await keycloak.loadUserInfo() as TUserInfo
    setUserInfo(user);
    const tenants = await getAllTenantsByAccount(user.email);
    user.tenants = tenants;
    const options = user.tenants?.map((tenant: ITenant) => ({
      key: tenant.id,
      text: tenant.tenantName
    })) as IKeyText[];
    setTenants(options);
    setSelectedTenant(options?.find(x => x.text == storageSelectedTenantGet()));
  };

  useEffect(() => {
    loadUserInfo();
  }, [initialized, keycloak]);
  
  return (
    <>
    {(initialized && keycloak.authenticated && tenants) &&
      <Autocomplete
        disableClearable={true}
        options={tenants}
        className={styles.tenantAutocomlete}
        getOptionLabel={(option) => option.text}
        value={
          tenants?.find(
            (option) => option.key === selectedTenant?.key
          ) || null
        }
        onChange={(_, newValue) => {
          setSelectedTenant(newValue as IKeyText);
          storageSelectedTenantSave(newValue?.text as string);
          window.location.reload();
        }
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Selecione uma conta"
            label="Conta"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
      />
    }
    </>
  );
};
